import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  RecipientListState,
  RECIPIENT_LIST_STATE,
} from './recipient-list.state';

export const selectRecipient =
  createFeatureSelector<RecipientListState>(RECIPIENT_LIST_STATE);

export const selectRecipientList = createSelector(
  selectRecipient,
  (state: RecipientListState) => {
    return state.dataSource;
  }
);

export const selectRecipientListFilter = createSelector(
  selectRecipient,
  (state: RecipientListState) => state.filter
);
